var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCapaOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.517 473.741L430.685 370.836C436.675 367.213 440.335 360.723 440.335 353.722V146.278C440.335 139.278 436.675 132.787 430.685 129.164L260.517 26.2586C254.154 22.4106 246.181 22.4106 239.818 26.2586L69.6506 129.164C63.6603 132.787 60 139.277 60 146.278V353.722C60 360.723 63.6603 367.213 69.6506 370.836L239.818 473.741C246.181 477.589 254.154 477.589 260.517 473.741Z",
    stroke: "white",
    strokeWidth: 34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 133.929L250.168 250.147M250.168 250.147L440.335 133.929M250.168 250.147V480",
    stroke: "white",
    strokeWidth: 34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCapaOutline);
export default __webpack_public_path__ + "static/media/ico_capa_outline.1e578449bdb9ee352874478708089ee1.svg";
export { ForwardRef as ReactComponent };